var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M77.39,47.75,52.59,23a2.25,2.25,0,0,1,3.18-3.18L86,50,55.77,80.23a2.25,2.25,0,0,1-3.18-3.18l24.8-24.8H16.25a2.25,2.25,0,0,1,0-4.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2);
export default __webpack_public_path__ + "static/media/ArrowRight2.c5b5652c6776f0cb26353507a7491fe7.svg";
export { ForwardRef as ReactComponent };